import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getpath } from "../../../actions/get-path";
import { datapop } from "../../../actions/data-populate";
import { timeupdate } from "../../../actions/timeupdate";
import TimeSheet from "./TimeSheet";
import { store } from "../../..";
import moment from "moment";
import { getaction, queryaction } from "../../../actions/get-action";
import {
  grabserviceredux,
  updateservice,
  deleteservice,
  createservice,
  getservice,
  grabservice
} from "../../../services/crudservice";
import { restauth, timeservice, app } from "../../..";
import {
  Checkbox, Label
} from "semantic-ui-react";
// import { RealTimeTime } from "../../../services/realtimetime";
import { modalhandler } from "../../../actions/modal-handler";
import movetime from "../../../services/movetime";
import jobsort from "../../../services/jobsort";
class TimeEntry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmed: false,
      currentweek: {},
      currentdates: null,
      readonly: false,
      monday: null,
      realtimesheet: [],
      localtime: [],
      empnumber: null,
      wods: [],
      jobs: [],
      payroll_dates: [],
      weekyyyymmdd: [],
    };
  }

  realtimetime(monday, sunday) {
    var empnumber = this.state.empnumber
      ? this.state.empnumber
      : this.props.myinfo.empnumber;

    app
      .service("dailylaborentries")
      .find({
        query: {
          empnumber: empnumber,
          dateperformed: {
            $gte: monday,
            $lte: sunday,
          },
        },
      })
      .then((response) => {
        console.log("Time Response", response);
        if (
          sunday <=
          moment()
            .endOf("isoWeek")
            .subtract(2, "weeks")
            .format("YYYY-MM-DD")
        ) {
          // console.log(readonly);
        }
        let readonly = false;
        if (
          sunday <=
          moment()
            .endOf("isoWeek")
            .subtract(3, "weeks")
            .format("YYYY-MM-DD")
        ) {
          readonly = true;
        }
        console.log(readonly);
        store.dispatch({
          type: "dailylabor params",
          payload: {
            monday,
            sunday,
            empnumber,
          },
        });
        store.dispatch(datapop(response, "dailylaborentries - Labor"));
        this.setState({
          readonly,
          confirmed: true,
        });
      });
  }
  findassignedjobs() {
    if (
      this.props.myinfo &&
      (this.props.myinfo.hradmin || this.props.myinfo.lsadmin)
    ) {
    } else {
      this.setState({
        jobs: this.props.jobs,
      });
    }
  }
  getlastweek() {
    let lastmonday = moment(this.state.monday).subtract(1, "weeks");
    //  this.timeservice.unsubscribe();

    this.genthosedates(lastmonday);
    this.setState({
      monday: lastmonday,
    });
  }
  getnextweek() {
    let nextmonday = moment(this.state.monday).add(1, "weeks");
    //    this.timeservice.unsubscribe();
    this.genthosedates(nextmonday);
    this.setState({
      monday: nextmonday,
    });
  }
  getwod(wodnumber) {
    console.log(this.state.weekyyyymmdd[6]);
    return this.props.wods.find((wod) => wod.workOrderNbr === wodnumber);
  }

  updatewod(data, wodnumber) {
    let wodservice = app.service("workorders");
    var chargetotal = 0;
    var budget;
    console.log(data);
    data.map((entry) => {
      let charge = entry.hours * entry.payrate;
      chargetotal = chargetotal + charge;
    });
    wodservice
      .get(wodnumber)
      .then((response) => {
        console.log(response.budget);
        budget = response.budget;
      })
      .then(() => {
        let remainingbudget = budget - chargetotal;
        console.log(remainingbudget);
        this.genthosedates(this.state.monday);
        wodservice.patch(wodnumber, {
          remaining: remainingbudget,
        });
      });
  }
  laborquery(wodnumber) {
    let queryservice = app.service("dailylaborentries");
    queryservice
      .find({
        query: {
          workordernumber: wodnumber,
        },
      })
      .then((response) => {
        this.updatewod(response, wodnumber);
      });
  }
  timeupdate(entry) {
    var found_entries = this.props.labor.filter(
      (fe) =>
        fe.dateperformed === entry.dateperformed &&
        fe.workordernumber === entry.workordernumber
    );
    console.log("found entries", found_entries);

    if (entry.id) {
      var entryobject = {
        ...entry,
        movetime: this.props.movetime,
      };
      if (entry.hours) {
        console.log("patching hours");
        if (this.props.movetime) {
          movetime(entry, "patch");
        } else {
          updateservice(
            "dailylaborentries",
            {
              ...entryobject,
              hours: entry.hours,
            },
            entry.id,
            "none"
          );
        }
      } else {
        found_entries.map((fe) => {
          console.log("deleting entry");
          if (this.props.movetime) {
            movetime(fe, "delete");
          } else {
            deleteservice("dailylaborentries", fe.id);
          }
        });
      }
    } else {
      if (entry.hours) {
        if (found_entries[0]) {
          var new_entry = found_entries[0];
          new_entry.hours += entry.hours;
          console.log("patching hours");
          if (this.props.movetime) {
            movetime(new_entry, "patch");
          } else {
            updateservice("dailylaborentries", new_entry, entry.id, "none");
          }
        } else {
          if (this.props.movetime) {
            movetime(entry, "create");
          } else {
            // console.log('Time Response', entry)
            createservice(
              "dailylaborentries",
              {
                ...entry,
                movetime: this.props.movetime,
              },
              "none"
            );
          }
        }
      }
    }
  }

  genthosedates(monday) {
    let tuesday = moment(monday)
      .add(1, "days")
      .format("YYYY-MM-DD");
    let wednesday = moment(monday)
      .add(2, "days")
      .format("YYYY-MM-DD");
    let thursday = moment(monday)
      .add(3, "days")
      .format("YYYY-MM-DD");
    let friday = moment(monday)
      .add(4, "days")
      .format("YYYY-MM-DD");
    let saturday = moment(monday)
      .add(5, "days")
      .format("YYYY-MM-DD");
    let sunday = moment(monday)
      .add(6, "days")
      .format("YYYY-MM-DD");
    let weekarray = [];
    let weekymd = [];
    let week = {
      mon: moment(monday).format("YYYY-MM-DD"),

      tue: tuesday,
      wed: wednesday,
      thu: thursday,
      fri: friday,
      sat: saturday,
      sun: sunday,
    };
    for (var i = 0; i < 7; i++) {
      let date = moment(monday)
        .add(i, "days")
        .format("MM/DD");
      weekarray.push(date);
    }
    for (var o = 0; o < 7; o++) {
      let date = moment(monday)
        .add(o, "days")
        .format("YYYY-MM-DD");
      weekymd.push(date);
    }
    let empnumber = this.state.empnumber
      ? this.state.empnumber
      : this.props.myinfo.empnumber;
    let jobs = this.props.jobs.filter(
      (job) => job.empnumber === empnumber && !job.removed
    );
    if (
      this.state.employee &&
      this.state.employee.empnumber === this.state.empnumber
    ) {
      let emp = this.state.employee;
      this.setState(
        {
          employee: emp,
          jobs: jobsort.assignments(emp.assigned),
          currentdates: weekarray,
          currentweek: week,
          weekyyyymmdd: weekymd,
          realtimesheet: [],
        },
        () => this.realtimetime(week.mon, week.sun)
      );
    } else {
      getservice("edfemployees", empnumber).then((emp) => {
        this.setState(
          {
            employee: emp,
            jobs: jobsort.assignments(emp.assigned),
            currentdates: weekarray,
            currentweek: week,
            weekyyyymmdd: weekymd,
            realtimesheet: [],
          },
          () => this.realtimetime(week.mon, week.sun)
        );
      });
    }
    this.getptoinfo(empnumber);
  }

  getexistinghours(date, empnumber, wod) {
    return restauth.get(
      "/dailylaborentries?dateperformed=" +
      date +
      "&empnumber=" +
      empnumber +
      "&workordernumber=" +
      wod
    );
  }
  handleInputchange(updatedentry) {
    let temptime = Array.from(this.props.labor);
    let timeindex = temptime.findIndex(
      (entry) =>
        entry.dateperformed === updatedentry.dateperformed &&
        entry.workordernumber === updatedentry.workordernumber
    );
    console.log("Updated Entry", updatedentry, timeindex);

    if (timeindex > -1) {
      temptime[timeindex] = updatedentry;
    } else {
      temptime = temptime.concat(updatedentry);
    }

    if (timeindex > -1 || updatedentry.hours) {
      store.dispatch({
        type: "local labor update",
      });
    } else {
      store.dispatch({
        type: "local labor canceled",
      });
    }

    this.setState({
      confirmed: false,
      localtime: temptime,
    });
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.myinfo &&
      !this.props.labor.length &&
      !this.state.currentdates
    ) {
      this.genthosedates(this.state.monday);
    }
    if (!prevProps.confirmed && this.props.confirmed) {
      this.genthosedates(this.state.monday);
    }
    this.genwods();
  }
  genwods() {
    if (
      this.props.wods &&
      this.props.jobs &&
      this.state.wods.length !== this.props.jobs.length
    ) {
      let newwods = [];
      this.props.jobs.map((job) => {
        let wod = this.props.wods.find(
          (wod) => wod.workOrderNbr === job.assigned_task
        );
        newwods = newwods.concat(wod);
      });
      this.setState({
        wods: newwods,
      });
    }
  }
  componentWillMount() {
    let mondaynoformat = moment().startOf("isoWeek");
    let monday = moment()
      .startOf("isoWeek")
      .format("YYYY-MM-DD");
    this.setState({
      monday: monday,
    });
  }
  grabLockedWeeks() {
    // console.log("Run Payroll");
    grabservice("run_payroll").then(res => this.setState({ payroll_dates: res }));
  }
  componentDidMount() {
    if (
      this.props.myinfo &&
      !this.state.realtimesheet.length &&
      !this.state.currentdates
    ) {
      console.log(this.state.monday);
      this.genthosedates(this.state.monday);
    }
    this.grabLockedWeeks();
    grabserviceredux("tmsheets", "tnmReducer");
    this.props.getpath("Time Entry", "hourglass empty");
  }
  getptoinfo(empnumber) {
    app
      .service("reports")
      .find({
        query: {
          report: "pto",
          empnumber: empnumber,
        },
      })
      .then((response) => {
        if (response.length) {
          response = response[0];
          this.setState({
            ptoinfo: response,
          });
        } else {
          this.setState({
            ptoinfo: "none",
          });
        }
      });
  }
  genTimentry(empnumber) {
    let emp_number = this.state.empnumber
      ? this.state.empnumber
      : this.props.myinfo.empnumber;
    var labor = this.state.confirmed
      ? Array.from(this.props.labor)
      : Array.from(this.state.localtime);
    let employeeinfo = this.props.employees.find(
      (emp) => emp.empnumber === emp_number
    );
    if (employeeinfo && !this.state.ptoinfo) {
      this.getptoinfo(empnumber);
    }
    var weekLocked = false
    if (this.state.payroll_dates.length) {
      weekLocked = this.state.payroll_dates.includes(this.state.weekyyyymmdd[6])
    }
    // console.log("weekyyyymmdd", this.state.payroll_dates, this.state.weekyyyymmdd[5]);

    return (
      <TimeSheet
        readonly={this.state.readonly && !this.props.movetime}
        timedelete={(Hours, wodnum, Date) =>
          this.timedelete(Hours, wodnum, Date)
        }
        weekLocked={weekLocked}
        lockWeek={() => {
          createservice("run_payroll", { payroll_date: this.state.weekyyyymmdd[6] }).then(() => this.grabLockedWeeks())
        }}
        unlockWeek={() => {
          console.log("Unlocking Week")
          deleteservice("run_payroll", this.state.weekyyyymmdd[6]).then(() => this.grabLockedWeeks())
        }}
        tnms={this.props.tnms}
        ptoinfo={this.state.ptoinfo}
        employeeinfo={employeeinfo}
        timeupdate={(entry) => {
          this.timeupdate(entry, labor);
          this.getptoinfo(empnumber);
        }}
        confirmed={this.state.confirmed}
        dates={this.state.weekyyyymmdd}
        getlastweek={() => this.getlastweek()}
        getnextweek={() => this.getnextweek()}
        handleDateSelect={(date) =>
          this.genthosedates(moment(date).startOf("isoWeek"))
        }
        employee={this.state.employee}
        wods={this.props.wods}
        realtimesheet={labor}
        changeemployee={(empnumber) => {
          this.setState(
            {
              empnumber: empnumber,
            },
            () => {
              this.genthosedates(this.state.monday);
            }
          );
        }}
        movetime={this.props.movetime}
        employees={this.props.employees}
        jobs={this.state.jobs}
        handleInputchange={(entry) => this.handleInputchange(entry)}
        mobile={this.props.mobile}
        empnumber={emp_number}
        myinfo={this.props.myinfo}
        currentdates={this.state.currentdates}
        handlemodal={(modal) => this.props.handlemodal(modal)}
      />
    );
  }
  render() {
    //move time param prevents move time tool from loading without tnms
    var movetime_param =
      !this.props.tnms.length && this.props.movetime ? false : true;
    if (this.props.myinfo && this.props.employees.length && movetime_param) {
      let empnumber = this.state.empnumber
        ? this.state.empnumber
        : this.props.myinfo.empnumber;
      return (
        <div className="TimeEntry" id="timetable">
          {" "}
          {this.genTimentry(this.props.mobile, empnumber)}{" "}
        </div>
      );
    } else {
      return <div> No T & M 's to move time too</div>;
    }
  }
}

function mapStateToProps(state) {
  return {
    tnms: state.tnms.all,
    confirmed: state.labor.confirmed,
    labor: state.labor.entries,
    employees: state.employees.active,
    jobs: state.jobs.assignedjobs,
    wods: state.workorders.derivitives,
    mobile: state.mobile,
    time: state.time.timequerydata,
    myinfo: state.myinfo.employeeinfo,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      handlemodal: modalhandler,
      queryaction: queryaction,
      getpath: getpath,
      timeupdate: timeupdate,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(TimeEntry);



// WEBPACK FOOTER //
// ./src/components/shared-components/timesheet/TimeEntryBuilder.js